import countries from '../helpers/hardcodedCountries';

const getCountries = () => countries;

export default getCountries;

